import { Navigate, Outlet } from "react-router-dom"
import { useState, useEffect } from "react"

import { Provider } from 'react-redux';
import { useAuth } from '../../context/AuthProvider';
import { store } from "../../redux";

const PersistLogin = () => {
  const { auth } = useAuth();

  if(auth.status==='unauthenticated'){
    return <Navigate to="/login" replace/>
  }

  if(auth.status==='loading'){
    return (
      <>Loading</>
    )
  }

  return (
    <>
    <Provider store={store}>
      {auth.status === 'authenticated' 
      ? <Outlet />
      : <Navigate to="/login" replace />
      }
    </Provider>
    </>
  )
}

export default PersistLogin